var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showCarousel && _vm.showContainer
    ? _c(
        "div",
        {
          staticClass: "carousel slide",
          class: [
            _vm.carouselSettings.crossfade ? "carousel-fade" : "",
            _vm.globalClasses,
          ],
          style: [_vm.globalStyle],
          attrs: {
            id: _vm.carouselSettings.carouselId,
            "data-ride": "carousel",
          },
        },
        [
          _vm.carouselSettings.indicators
            ? _c(
                "ol",
                { staticClass: "carousel-indicators" },
                _vm._l(_vm.columns, function (el, i) {
                  return _c("li", {
                    class: [
                      i === 0 ? "active" : "",
                      "bg-" + _vm.carouselSettings.apperance,
                    ],
                    attrs: {
                      "data-target": "#" + _vm.carouselSettings.carouselId,
                      "data-slide-to": i,
                    },
                  })
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "carousel-inner" },
            _vm._l(_vm.$slots.columns, function (col, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "carousel-item",
                  class: [index === 0 ? "active" : ""],
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "widget-inner",
                      class: _vm.classColumns[index],
                      style: [_vm.stylesColumns[index]],
                    },
                    [_c("slot-component", { attrs: { vnode: col } })],
                    1
                  ),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.carouselSettings.controls
            ? _c(
                "a",
                {
                  staticClass: "carousel-control-prev",
                  attrs: {
                    href: "#" + _vm.carouselSettings.carouselId,
                    role: "button",
                    "data-slide": "prev",
                  },
                },
                [
                  _c("span", {
                    staticClass: "fa fa-chevron-left fa-lg",
                    class: "text-" + _vm.carouselSettings.apperance,
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [_vm._v("Previous")]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.carouselSettings.controls
            ? _c(
                "a",
                {
                  staticClass: "carousel-control-next",
                  attrs: {
                    href: "#" + _vm.carouselSettings.carouselId,
                    role: "button",
                    "data-slide": "next",
                  },
                },
                [
                  _c("span", {
                    staticClass: "fa fa-chevron-right fa-lg",
                    class: "text-" + _vm.carouselSettings.apperance,
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [_vm._v("Next")]),
                ]
              )
            : _vm._e(),
        ]
      )
    : _vm.showContainer && _vm.columns === 2
    ? _c(
        "div",
        {
          staticClass: "widget-grid widget-two-col row",
          class: [_vm.noGutters, _vm.globalClasses],
          style: [_vm.globalStyle],
        },
        _vm._l(_vm.$slots.columns, function (col, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "widget-inner",
              class: [_vm.classGrids[index], _vm.classColumns[index]],
              style: [_vm.stylesColumns[index]],
              attrs: { id: _vm.idColumns[index] },
            },
            [_c("slot-component", { attrs: { vnode: col } })],
            1
          )
        }),
        0
      )
    : _vm.showContainer && _vm.columns === 3
    ? _c(
        "div",
        {
          staticClass: "widget-grid widget-three-col row",
          class: [_vm.noGutters, _vm.globalClasses],
          style: [_vm.globalStyle],
        },
        [
          _vm.layout === "oneStackedToTwo"
            ? [
                _c(
                  "div",
                  {
                    staticClass: "widget-inner widget-inner-stacked col-12",
                    class: [
                      _vm.layoutTablet === "stackedTablet"
                        ? "tablet-stacked"
                        : "",
                      _vm.classGrids[0],
                    ],
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "widget-inner row",
                        class: [_vm.noGutters],
                      },
                      [
                        _c("slot-component", {
                          attrs: { vnode: _vm.$slots.columns[0] },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "widget-inner row",
                        class: [_vm.noGutters],
                      },
                      [
                        _c("slot-component", {
                          attrs: { vnode: _vm.$slots.columns[1] },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "widget-inner col-12",
                    class: [_vm.classGrids[1], _vm.classColumns[2]],
                    style: [_vm.stylesColumns[2]],
                    attrs: { id: _vm.idColumns[2] },
                  },
                  [
                    _c("slot-component", {
                      attrs: { vnode: _vm.$slots.columns[2] },
                    }),
                  ],
                  1
                ),
              ]
            : _vm.layout === "twoToOneStacked"
            ? [
                _c(
                  "div",
                  {
                    staticClass: "widget-inner col-12",
                    class: [_vm.classGrids[0], _vm.classColumns[0]],
                    style: [_vm.stylesColumns[0]],
                    attrs: { id: _vm.idColumns[0] },
                  },
                  [
                    _c("slot-component", {
                      attrs: { vnode: _vm.$slots.columns[0] },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "widget-inner widget-inner-stacked col-12",
                    class: [
                      _vm.layoutTablet === "stackedTablet"
                        ? "tablet-stacked"
                        : "",
                      _vm.classGrids[1],
                    ],
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "widget-inner row",
                        class: [_vm.noGutters],
                      },
                      [
                        _c("slot-component", {
                          attrs: { vnode: _vm.$slots.columns[1] },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "widget-inner row",
                        class: [_vm.noGutters],
                      },
                      [
                        _c("slot-component", {
                          attrs: { vnode: _vm.$slots.columns[2] },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            : _vm._l(_vm.$slots.columns, function (col, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "widget-inner col-12",
                    class: [_vm.classGrids[index], _vm.classColumns[index]],
                    style: [_vm.stylesColumns[index]],
                    attrs: { id: _vm.idColumns[index] },
                  },
                  [_c("slot-component", { attrs: { vnode: col } })],
                  1
                )
              }),
        ],
        2
      )
    : _vm.showContainer && _vm.columns === 4
    ? _c(
        "div",
        {
          staticClass: "widget-grid widget-four-col row",
          class: [_vm.noGutters, _vm.globalClasses],
          style: [_vm.globalStyle],
        },
        [
          _vm.layout === "oneStackedToTwo" ||
          _vm.layout === "oneStackedToOne" ||
          _vm.layout === "twoStackedToOne"
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "widget-inner widget-inner-stacked grid-four col-12",
                    class: [
                      _vm.layoutTablet === "stacked" ? "tablet-stacked" : "",
                      _vm.classGrids[0],
                    ],
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "widget-inner row",
                        class: [_vm.noGutters],
                      },
                      [
                        _c("slot-component", {
                          attrs: { vnode: _vm.$slots.columns[0] },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "widget-inner row",
                        class: [_vm.noGutters],
                      },
                      [
                        _c("slot-component", {
                          attrs: { vnode: _vm.$slots.columns[1] },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "widget-inner row",
                        class: [_vm.noGutters],
                      },
                      [
                        _c("slot-component", {
                          attrs: { vnode: _vm.$slots.columns[2] },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "widget-inner col-12",
                    class: [_vm.classGrids[1], _vm.classColumns[3]],
                    style: [_vm.stylesColumns[3]],
                    attrs: { id: _vm.idColumns[3] },
                  },
                  [
                    _c("slot-component", {
                      attrs: { vnode: _vm.$slots.columns[3] },
                    }),
                  ],
                  1
                ),
              ]
            : _vm.layout === "twoToOneStacked" ||
              _vm.layout === "oneToOneStacked" ||
              _vm.layout === "oneToTwoStacked"
            ? [
                _c(
                  "div",
                  {
                    staticClass: "widget-inner col-12",
                    class: [_vm.classGrids[0], _vm.classColumns[0]],
                    style: [_vm.stylesColumns[0]],
                    attrs: { id: _vm.idColumns[0] },
                  },
                  [
                    _c("slot-component", {
                      attrs: { vnode: _vm.$slots.columns[0] },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "widget-inner widget-inner-stacked grid-four col-12",
                    class: [
                      _vm.layoutTablet === "stacked" ? "tablet-stacked" : "",
                      _vm.classGrids[1],
                    ],
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "widget-inner row",
                        class: [_vm.noGutters],
                      },
                      [
                        _c("slot-component", {
                          attrs: { vnode: _vm.$slots.columns[1] },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "widget-inner row",
                        class: [_vm.noGutters],
                      },
                      [
                        _c("slot-component", {
                          attrs: { vnode: _vm.$slots.columns[2] },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "widget-inner row",
                        class: [_vm.noGutters],
                      },
                      [
                        _c("slot-component", {
                          attrs: { vnode: _vm.$slots.columns[3] },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            : _vm._l(_vm.$slots.columns, function (col, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "widget-inner col-12",
                    class: [_vm.classGrids[index], _vm.classColumns[index]],
                    style: [_vm.stylesColumns[index]],
                    attrs: { id: _vm.idColumns[index] },
                  },
                  [_c("slot-component", { attrs: { vnode: col } })],
                  1
                )
              }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }